<!--
  Copyright (C) 2020 ExploRêve

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see <https://www.gnu.org/licenses/>.

  Full source code is available at <https://gitlab.com/exploreve/frontend>.
-->

<template>
  <div class="gare-container">
    <div v-show="!hasSeen">
      <div class="row row-para">
        <div class="col-md-6">
          <div>
            <img class="erwin-img para" src="https://cdn.exploreve.fr/content/personnages/erwin.svg" height="300px" />
            <img class="daria-img para" src="https://cdn.exploreve.fr/content/personnages/daria.svg" height="300px" />
            <img class="leon-img para" src="https://cdn.exploreve.fr/content/personnages/leon.svg" height="400px" />
          </div>
        </div>
        <div class="col-md-6">
          <div class="left">
            <div class="arrowleft"></div>
            <p>
              Je ne pense pas que nous soyons encore prêt·es à décoller les jeunes... Regardons ce qui manque sur la
              liste et continuons nos recherches ! J'ai entendu dire qu'il faudrait que nous allions voir une
              mécanicienne quand on aura tout recolté. Apparemment elle se trouve en dehors du jamborée, vers l'ouest.
            </p>
          </div>
        </div>
      </div>
    </div>
    <div v-show="hasSeen">
      <div class="row row-para" v-show="step == 1">
        <div class="col-md-8">
          <div>
            <img class="meca-img para" src="https://cdn.exploreve.fr/content/cluedo/Mecanicienne.svg" height="400px" />
            <img class="daria-img-2 para" src="https://cdn.exploreve.fr/content/personnages/daria.svg" height="280px" />
            <img class="leon-img-2 para" src="https://cdn.exploreve.fr/content/personnages/leon.svg" height="400px" />
            <img
              class="ballon-img-2 para"
              src="https://cdn.exploreve.fr/content/ballons/ballon_violet.svg"
              height="250px"
            />
          </div>
        </div>
        <div class="col-md-4">
          <div class="left_para">
            <div class="arrowleft"></div>
            <p>
              Je crois qu’on a tout ce qu’il nous faut. On a besoin de quelques minutes de réglages, Marie va me donner
              un coup de main. Pendant ce temps, est-ce que vous pouvez préparer notre itinéraire de vol ? La carte que
              j'ai sous la main est bien vieille… une partie est toute effacée par le soleil et des années de voyage.
              Peut-être pouvez-vous quand même en tirer quelque chose ? Avec un peu de logique, vous devriez pouvoir
              déduire les informations manquantes…
            </p>
          </div>
          <div class="object para_R" @click="step += 1">
            Réparer la carte
          </div>
        </div>
      </div>
      <div class="row row-para" v-show="step == 2">
        <div class="col-md-1">
          <div style="font-family: 'faune'; width: 200px; position: absolute; left: -20px; top: 30px;">
            <div style="position: relative; left: -30px;">
              <p>Liste des symboles</p>
            </div>
            <div v-for="k in 6" :key="k">
              <img :src="'https://cdn.exploreve.fr/content/cluedo/' + sdk_list[k]" class="sdk_list" />
            </div>
          </div>
        </div>
        <div class="col-md-7">
          <div class="sdk_container">
            <div class="tile-ct">
              <div class="border-ct">
                <div v-for="n in sdk_num.length" :key="n" @mousedown="fired">
                  <div v-for="k in sdk_num[n - 1].length" :key="k">
                    <div v-show="k - 1 == pos[n - 1]">
                      <img
                        class="sdk_tile"
                        :src="'https://cdn.exploreve.fr/content/cluedo/' + sdk_list[sdk_num[n - 1][k - 1]]"
                        :id="n * 1000 + k"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="barv v1"></div>
            <div class="barv v2"></div>
            <div class="barh"></div>
          </div>
          <div class="object" style="margin-top: 2px;" @click="verif">Réparer la carte</div>
          <div v-show="display && !succ" class="reponse">
            Mauvaise réponse ! Vérifie bien que tu n’as qu’un symbole par ligne, colonne et rectangle !
          </div>
        </div>
        <div class="col-md-3">
          <div class="bot_para">
            <p>
              Clique sur les cases vides pour modifier le symbole. Attention, pour gagner, chaque symbole ne doit
              apparaître qu’une fois dans chaque ligne, chaque colonne et chaque rectangle !
            </p>
            <div class="arrow-sdk"></div>
          </div>
          <img class="leon-img-3 para" src="https://cdn.exploreve.fr/content/personnages/leon.svg" height="300px" />
        </div>
      </div>
      <div class="row row-para" v-show="step == 3">
        <div class="col-md-6">
          <div>
            <img class="erwin-img para" src="https://cdn.exploreve.fr/content/personnages/erwin.svg" height="300px" />
            <img class="daria-img para" src="https://cdn.exploreve.fr/content/personnages/daria.svg" height="300px" />
            <img class="leon-img para" src="https://cdn.exploreve.fr/content/personnages/leon.svg" height="400px" />
          </div>
        </div>
        <div class="col-md-6">
          <div class="left">
            <div class="arrowleft"></div>
            <p>
              C'est bon, tout me semble prêt le décollage, allons-y !
            </p>
          </div>

          <div class="object" style="margin-top: 200px;">
            <NextBtn url="/immersion02/3" text="Décoller !" />
          </div>
          <img src="https://cdn.exploreve.fr/content/ballons/ballon_rose.svg" height="300px" class="ballon_final" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import NextBtn from "@/components/NextButton";

export default {
  data: function () {
    return {
      step: 1,
      sdk_list: [
        "SDKvide-24.svg",
        "SDKForet.svg",
        "SDKLac.svg",
        "SDKMontagne.svg",
        "SDKPlaine.svg",
        "SDKVallee.svg",
        "SDKVillage.svg"
      ],
      sdk_num: [
        [0, 1, 2, 3, 4, 5, 6],
        [0, 1, 2, 3, 4, 5, 6],
        [3],
        [0, 1, 2, 3, 4, 5, 6],
        [4],
        [0, 1, 2, 3, 4, 5, 6],
        [6],
        [5],
        [0, 1, 2, 3, 4, 5, 6],
        [4],
        [1],
        [0, 1, 2, 3, 4, 5, 6],
        [0, 1, 2, 3, 4, 5, 6],
        [3],
        [1],
        [6],
        [0, 1, 2, 3, 4, 5, 6],
        [2],
        [5],
        [0, 1, 2, 3, 4, 5, 6],
        [6],
        [3],
        [2],
        [0, 1, 2, 3, 4, 5, 6],
        [0, 1, 2, 3, 4, 5, 6],
        [6],
        [4],
        [0, 1, 2, 3, 4, 5, 6],
        [3],
        [5],
        [0, 1, 2, 3, 4, 5, 6],
        [4],
        [5],
        [2],
        [0, 1, 2, 3, 4, 5, 6],
        [0, 1, 2, 3, 4, 5, 6]
      ],
      pos: Array(36).fill(0),
      sol: [1, 2, 3, 5, 4, 6, 6, 5, 2, 4, 1, 3, 4, 3, 1, 6, 5, 2, 5, 1, 6, 3, 2, 4, 2, 6, 4, 1, 3, 5, 3, 4, 5, 2, 6, 1],
      display: false,
      succ: false
    };
  },
  mounted() {
    for (let n = 0; n < this.sdk_num.length; n++) {
      if (this.sdk_num[n].length > 1) {
        for (let k = 0; k < this.sdk_num[n].length; k++) {
          var tile = document.getElementById(1000 * (n + 1) + k + 1);

          tile.classList.add("moveable_sdk");
        }
      }
    }
  },
  methods: {
    fired(event) {
      var i = Math.trunc(event.target.id / 1000) - 1;
      this.pos[i] = (this.pos[i] + 1) % this.sdk_num[i].length;
      this.pos = [...this.pos];
    },

    verif() {
      let test = true;
      for (let n = 0; n < this.sdk_num.length; n++) {
        test = test && this.sol[n] == this.sdk_num[n][this.pos[n]];
      }
      this.succ = test;
      if (test) {
        this.step += 1;
      }
      this.display = true;
    }
  },
  props: {
    hasSeen: Boolean
  },
  components: {
    NextBtn
  }
};
</script>
<style>
.ballon_final {
  position: relative;
  left: 350px;
  top: -150px;
}
.reponse {
  color: red;
  font-family: "faune";
  text-align: center;
}
.barv {
  background: white;
  height: 365px;
  width: 2px;
  border-radius: 1px;
  position: absolute;
  top: 20px;
  z-index: 3;
}
.v1 {
  left: 172px;
}
.v2 {
  left: 282px;
}
.barh {
  background: white;
  height: 2px;
  width: 365px;
  border-radius: 1px;
  position: absolute;
  left: 44px;
  top: 200px;
  z-index: 3;
}
.border-ct {
  margin: auto;
  width: 340px;
  height: 340px;
  position: relative;
  top: 35px;
}

.tile-ct {
  width: 400px;
  height: 400px;
  background-image: url("https://cdn.exploreve.fr/content/cluedo/Sudoku-21.svg");
  margin: auto;
  position: relative;
  top: 0px;
}
.sdk_tile {
  width: 55px;
  float: left;
  border: 1px solid transparent;
}
.moveable_sdk {
  width: 55px;
  float: left;
  border: 1px solid #996d42;
}
.sdk_background {
  margin: 0px;
  position: absolute;
  z-index: 0;
}

.sdk_list {
  width: 40px;
  margin: 10px;
}

.row-para {
  width: 800px !important;
}
.para_R {
  width: 300px;
}
.para {
  position: absolute;
}
.erwin-img {
  top: 100px;
  left: -10px;
  z-index: 2;
}
.daria-img {
  top: 100px;
  left: 10px;
  z-index: 1;
}
.leon-img {
  top: 40px;
  left: 180px;
  z-index: 3;
}
.leon-img-2 {
  top: 40px;
  left: 300px;
  z-index: 3;
}
.daria-img-2 {
  top: 140px;
  left: -60px;
  z-index: 5;
}
.meca-img {
  top: 40px;
  left: 120px;
  z-index: 3;
}
.ballon-img-2 {
  top: -10px;
  left: -70px;
  z-index: 3;
}

.leon-img-3 {
  top: 180px;
  left: 100px;
}

.left_para,
.bot_para {
  font-family: "Faune";
  display: table;
  padding: 10px;
  background-color: white;
  border-radius: 5px;
  margin: 20px;
  width: intrinsic; /* Safari/WebKit utilisent un nom non-standard */
  width: -moz-max-content; /* Firefox/Gecko */
  width: -webkit-max-content;
}

.left_para {
  padding-left: 0px;
  margin-left: 20px;
  margin-right: auto;
  max-width: 300px;
}

.bot_para {
  margin: 10px;
  max-width: 280px;
}

.arrow-sdk {
  position: relative;
  content: "";
  top: 150px;
  left: -150px;
  width: 0px;
  height: 0px;
  border-left: 15px solid transparent;
  border-right: 15px solid transparent;
  border-top: 15px solid white;
}
</style>
